// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1HMZO,.l6o0k,.l6o0k [id^=adfox],.l6o0k aside{height:100%}._1HMZO{position:absolute;z-index:1;top:0;left:0;width:100%;padding:16px;border:1px solid #e2e2e2;background:#fff;border-radius:8px}.w5Yi2>:first-child{height:18px}._2JPv7,.w5Yi2>:last-child{margin-top:20px}._2JPv7>:first-child,._2JPv7>:last-child{width:95%;height:20px;margin-top:4px}._2JPv7>:last-child{width:90%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": "_1HMZO",
	"root": "l6o0k",
	"loaderTitle": "w5Yi2",
	"loaderText": "_2JPv7"
};
module.exports = ___CSS_LOADER_EXPORT___;
